// Landing page: a small "servers online" line from the battle server's
// /health (players online, queue). Hidden when the API can't be reached.

interface Health {
	status?: string;
	playersOnline?: number;
	queue?: number;
	liveMatches?: number;
}

async function serverStatus(): Promise<void> {
	const el = document.querySelector<HTMLElement>(".server-status");
	const text = document.querySelector<HTMLElement>(
		".server-status .server-text",
	);
	if (!el || !text) return;
	try {
		const cfg = (await (await fetch("/healthz")).json()) as { api?: string };
		if (!cfg.api) return;
		const res = await fetch(`${cfg.api.replace(/\/+$/, "")}/health`, {
			signal: AbortSignal.timeout(4000),
		});
		const h = (await res.json()) as Health;
		if (h.status !== "ok") throw new Error("down");
		const players =
			typeof h.playersOnline === "number" ? h.playersOnline : null;
		const live = typeof h.liveMatches === "number" ? h.liveMatches : null;
		const parts = ["Servers online"];
		if (players !== null)
			parts.push(`${players} ${players === 1 ? "player" : "players"}`);
		if (live) parts.push(`${live} ${live === 1 ? "match" : "matches"} live`);
		text.textContent = parts.join(" · ");
		el.hidden = false;
	} catch {
		// Unreachable or no CORS: say nothing rather than "offline".
	}
}

void serverStatus();

export {};
